const KEYBOARD_SHORTCUTS = {
    driver: {
        u: 'revenue',
        a: 'working-time',
        s: 'shifts',
        e: 'trips',
        k: 'card-payments',
        m: 'employees',
    },
    car: {
        u: 'revenue',
        s: 'shifts',
        e: 'trips',
        b: 'operationride',
        f: 'cars',
    },
    concession: {
        e: 'trips',
        s: 'shifts',
        f: 'cars',
    },
};

const getButtonShowKey = (page) => {
    const keyMap = {
        revenue: 'showRevenueButton',
        'working-time': 'showWorkingTimeButton',
        shifts: 'showShiftsButton',
        trips: 'showTripsButton',
        'card-payments': 'showCardPaymentsButton',
        employees: 'showEmployeesButton',
        operationride: 'showOperationRideButton',
        cars: 'showCarsButton',
    };
    return keyMap[page] || null;
};

export const createKeyboardHandler = (
    entityType,
    isPlanBasic,
    showButtons,
    handleNavigate,
    navigateMonth,
    canNavigatePrev,
    canNavigateNext,
) => {
    return (e) => {
        if (e.key === 'ArrowLeft' && canNavigatePrev) {
            e.preventDefault();
            navigateMonth(-1);
            return;
        }
        if (e.key === 'ArrowRight' && canNavigateNext) {
            e.preventDefault();
            navigateMonth(1);
            return;
        }

        const key = e.key.toLowerCase();
        const shortcuts = KEYBOARD_SHORTCUTS[entityType] || {};
        const page = shortcuts[key];

        if (page) {
            const buttonKey = getButtonShowKey(page);
            if (buttonKey && showButtons[buttonKey]) {
                e.preventDefault();
                handleNavigate(page);
            }
        }
    };
};
